"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_helmet_1 = require("react-helmet");
const Hooks_1 = require("@/Hooks");
const Theme_1 = require("@/Theme");
const TITLE_PLACEHOLDER = 'Haldex | ';
function Meta() {
    const page = (0, Hooks_1.useCurrentPage)();
    const { name } = page || {};
    const defaultTitle = name ? TITLE_PLACEHOLDER.concat(name) : 'Haldex';
    const [title, setTitle] = (0, react_1.useState)(defaultTitle);
    (0, react_1.useEffect)(() => {
        setTitle(defaultTitle);
    }, [name]);
    return (react_1.default.createElement(react_helmet_1.Helmet, null,
        react_1.default.createElement("title", null, title),
        react_1.default.createElement("link", { rel: "shortcut icon", href: "/assets/spa/favicon.ico", type: "image/x-icon" }),
        react_1.default.createElement("meta", { name: "theme-color", content: Theme_1.theme.palette.BLUE_100 })));
}
exports.default = Meta;
